import React, { Fragment, useEffect, useState } from "react";
import { Button, Container, Modal, Nav } from "react-bootstrap";
import ResumeCard from "./resumcard";
import { failedMessage } from "utils/httpClient";
import { apiCall } from "utils/httpClient";
import apiEndPoint from "utils/apiEndPoint";
import { isEmpty } from "utils/utils";
import { FaDesktop, FaMobileAlt } from "react-icons/fa";
import { loadFromLocalStorage } from "utils/LocalStorageUtils";
import DomainSelection from "pages/selectdomain";

function ManageTemplates() {
  const [orderList, setOrderList] = useState([]);
  const [siteUrl, setSiteUrl] = useState('');
  const [base_url, setbaseurl] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showSwitchTemp, setShowSwitchTemp] = useState(false);
  const [showSTemplteList, setShowSTemplteList] = useState(false);
  const [selectTemplate, setSelectTemplate] = useState({});
  const [selectNewTemplate, setSelectNewTemplate] = useState(null);
  const [activeTab, setActiveTab] = useState("Desktop");
  const [selectActiveTab, setSelectActiveTab] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templatesList, setTemplatesList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [languageData, setLanguageData] = useState(null);
  const [selectOrderTemplate, setSelectOrderTemplate] = useState(null);
  const [selectShowModule, setSelectShowModule] = useState('list');
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  const authData = loadFromLocalStorage("AUTH_DATA");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])

  useEffect(() => {
    getOrderList();
  }, [currentPage]);

  const getOrderList = async () => {
    let params = { limit: 6, offset: currentPage === 0 ? 0 : currentPage - 1 }
    let header = { token: authData?.token }
    const { data } = await apiCall("post", apiEndPoint.GETORDERLIST, params, header);
    if (data.status === 200) {
      setOrderList(data.data);
      setSiteUrl(data.site_url);
      setbaseurl(data.base_url);
      setTotalPages(Math.ceil(data?.total_data / 6));
    } else {
      setOrderList([]);
      failedMessage(data.message);
    }
  };
  const handleViewClick = (template) => {
    setSelectedTemplate(template);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTemplate(null);
  };


  const getTemplateList = async (cat_id) => {
    let params = { limit: 30, offset: 0 }
    if (!isEmpty(cat_id)) {
      params['category_id'] = cat_id
      const { data } = await apiCall('post', apiEndPoint.GETTEMPLATE, params);
      console.log(data)
      if (data.status === 200) {
        setTemplatesList(data.data)
      }
      else {
        setTemplatesList([])
        failedMessage(data.message);
      }
    }
  };

  const handleOpenSwitchTemplate = (item) => {
    setSelectTemplate(item)
    setShowSwitchTemp(true)
    setShowSTemplteList(true)
    getTemplateList(item?.category_id)
  };

  const handleSelectChange = (e) => {
    const selObj = templatesList.length > 0 ? templatesList.find(i => i._id === e.target.value) : {}
    setSelectNewTemplate(selObj);
    setShowSTemplteList(false)
  };

  const handleCloseleSwitch = async () => {
    if (!isEmpty(selectNewTemplate?._id)) {
      let params = { order_id: selectTemplate?._id, old_template: selectTemplate?.template_id, new_template: selectNewTemplate?._id }
      const { data } = await apiCall('post', apiEndPoint.SWITCHTEMPLATE, params);
      if (data.status === 200) {
        getOrderList();
        setSelectTemplate(null)
        setSelectNewTemplate(null)
        setShowSwitchTemp(false)
      }
    }
  };
  const handleSelectDomain = async (item) => {
    item.order_id = item?._id
    setSelectOrderTemplate(item)
    setSelectShowModule('selectDomain')
  }
  const handleBackPage = () => {
    getOrderList()
    setSelectShowModule('list')
    setSelectOrderTemplate(null)
  };

  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {

    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    if (!selectActiveTab && window.innerWidth < 992) {
      setActiveTab('Mobile')
    } else if (!selectActiveTab && window.innerWidth > 992) {
      setActiveTab('Desktop')
    }
    window.addEventListener('resize', handleResize);
    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]');
    if (meta) {
      if (showModal && selectActiveTab && activeTab === 'Desktop' && screenSize?.width < 768) {
        meta.setAttribute('content', 'width=1200, user-scalable=no');
      } else {
        meta.setAttribute('content', 'width=device-width, initial-scale=1');
      }
    }
  }, [activeTab, showModal]);
  return (
    <Fragment>
      {selectShowModule === 'list' &&
        <div>
          <section className="services-section">
            <div className="container text-center">
              <h3 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', fontWeight: 600, textAlign: 'center', margin: 'auto' }}>
                {languageData?.manageYourTemplates}
              </h3>
              <br />
              <p style={{ fontSize: 16, fontWeight: 600, maxWidth: 800, margin: 'auto', color: '#444' }}>
                {languageData?.hereYouCanManageUptoTemplates}
              </p>
            </div>
          </section>
          <Container className="" style={{ marginBottom: '1rem' }}>
            <div className="card">
              {orderList.length > 0 && orderList.map(resume => (
                <ResumeCard
                  item={resume}
                  key={resume._id}
                  title={resume?.templates_title}
                  status={resume?.order_status}
                  name={resume?.path_name}
                  domainName={!isEmpty(resume?.domain) ? resume?.domain : resume?.path_name}
                  thumbnail={resume?.thumbnail}
                  onEdit={() => console.log(`Edit ${resume?.templates_title}`)}
                  onPublish={() => console.log(`Publish ${resume?.templates_title}`)}
                  onSwitch={() => console.log(`Switch Template ${resume?.templates_title}`)}
                  getOrderList={getOrderList}
                  template_path={resume?.template_path}
                  publishable={resume?.publishable}
                  handleViewClick={handleViewClick}
                  handleOpenSwitchTemplate={handleOpenSwitchTemplate}
                  handleSelectDomain={handleSelectDomain}
                />
              ))}
            </div>
          </Container>
        </div>
      }

      {/* Modal for Viewing Template */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        size={activeTab === "Desktop" ? "xl" : "md"} // Set modal size based on active tab
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>{selectedTemplate?.templates_title}</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Nav variant="tabs" activeKey={activeTab} onSelect={(selectedTab) => { setActiveTab(selectedTab); setSelectActiveTab(true) }} className="justify-content-center text-center align-items-center">
            <Nav.Item>
              <Nav.Link eventKey="Desktop">
                <FaDesktop className="me-2" />
                {languageData?.desktop}
              </Nav.Link>
            </Nav.Item>
            <div className="nav-separator"></div> {/* Separator line */}
            <Nav.Item>
              <Nav.Link eventKey="Mobile">
                <FaMobileAlt className="me-2" />
                {languageData?.mobile}
              </Nav.Link>
            </Nav.Item>
          </Nav>
          {/* <iframe src={selectedTemplate?.template_path} width="100%" height="650"></iframe> */}

          {/* <div className="templatethumb-card">
            <div className={activeTab === "Desktop" ? 'desktop-iframe' : 'mobile-iframe'}>
              <iframe src={selectedTemplate?.template_path} width="100%" height={selectActiveTab && activeTab === "Desktop" && screenSize?.width < 992 ? '1500' : "500"}></iframe>
            </div>
          </div> */}

              
          <div className="templatethumb-card">
            <div className={activeTab === "Desktop" ? 'desktop-iframe' : 'mobile-iframe'}>
              <iframe src={selectedTemplate?.template_path} width="100%" height={selectActiveTab && activeTab === "Desktop" ? '1500' : "700"}></iframe>
            </div>
          </div>
        </Modal.Body>

      </Modal>

      {/* switch template  */}
      <Modal centered show={showSwitchTemp} onHide={() => setShowSwitchTemp(false)} style={{ fontFamily: 'quicksand' }}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 18, fontWeight: 600 }}>{languageData?.doYouWishSwitchThisTemplate}</Modal.Title>
        </Modal.Header>
        <Modal.Body> {languageData?.currentThemeWeillBeSwitched}
          <br /> <br />
          <p className='mb-0'>{languageData?.currentTheme}: {selectTemplate?.templates_title}</p>
          {!isEmpty(selectNewTemplate) &&
            <div style={{ display: 'flex', 'justify-content': 'space-between', width: '100%' }}>
              <p>{languageData?.newTheme}: {selectNewTemplate?.title}</p>
              <span onClick={() => setShowSTemplteList(true)} style={{ fontSize: '14px', color: '#0d6efd', fontWeight: 700, cursor: 'pointer' }}>{languageData?.change}</span>
            </div>
          }
          {showSTemplteList &&
            <div style={{ marginTop: '2px' }}>
              <label><b> {languageData?.newTheme}</b></label>
              <select className="form-control" value={selectNewTemplate?._id} onChange={handleSelectChange} >
                <option>{languageData?.selectNewTheme}</option>
                {templatesList.length > 0 && templatesList.map((item, i) => (
                  item?._id != selectTemplate?.template_id &&
                  <option value={item?._id}>{item?.title}</option>
                ))}
              </select>
            </div>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button style={{ margin: '5px', borderRadius: 15, width: 'inherit', fontSize: 12, fontWeight: 500 }} size='md' variant="secondary" onClick={() => setShowSwitchTemp(false)}>
            {languageData?.cancel}
          </Button>
          <Button style={{ margin: '5px', borderRadius: 15, width: 'inherit', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }} size='md' onClick={() => handleCloseleSwitch()}>
            {languageData?.switch}
          </Button>
        </Modal.Footer>
      </Modal>
      {selectShowModule === 'selectDomain' &&
        <div>
          <DomainSelection orderDetail={selectOrderTemplate} handleBackPage={handleBackPage} />
        </div>
      }

      <hr />
    </Fragment>
  );
}

export default ManageTemplates;